import React from "react";
import { Box, Paper } from "@mui/material";
import CardHeaderTitle from "../../components/card-header-title/index.jsx";

const TalkRatioCard = ({ data, colours, FONT }) => {

    return (
        <Paper
            sx={{ display: "flex", flexDirection: "column", width: { xs: '100%', sm: '50%' }, borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
        >
            <CardHeaderTitle
                title="Talk Ratio"
                tooltip="The ratio between Agent speaking time, Client speaking time, and silence in a recording."
            />
            <Box marginTop={2} display="flex" flexDirection="row" gap={1} textAlign="center">
                <Box>
                    <div style={{ fontSize: FONT.SIZE_20, fontWeight: "600" }}>{data.agent}</div>
                    <div style={{ fontSize: FONT.SIZE_12, color: colours.grayDark }}>
                        Agent
                    </div>
                </Box>
                <Box>
                    <div style={{ fontSize: FONT.SIZE_20, fontWeight: "600" }}>:</div>
                </Box>
                <Box>
                    <div style={{ fontSize: FONT.SIZE_20, fontWeight: "600" }}>{data.client}</div>
                    <div style={{ fontSize: FONT.SIZE_12, color: colours.grayDark }}>
                        Client
                    </div>
                </Box>
                <Box>
                    <div style={{ fontSize: FONT.SIZE_20, fontWeight: "600" }}>:</div>
                </Box>
                <Box>
                    <div style={{ fontSize: FONT.SIZE_20, fontWeight: "600" }}>{data.silence}</div>
                    <div style={{ fontSize: FONT.SIZE_12, color: colours.grayDark }}>
                        Silence
                    </div>
                </Box>
            </Box>
        </Paper>
    );
};

export default TalkRatioCard;